
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "10 raisons de choisir WordPress pour votre site web",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez pourquoi WordPress est le CMS idéal pour votre site : sécurité, SEO, adaptabilité mobile, support étendu, et bien plus encore.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "10 raisons de choisir WordPress pour votre site web",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Découvrez pourquoi WordPress est le CMS idéal pour votre site : sécurité, SEO, adaptabilité mobile, support étendu, et bien plus encore.",
        },
      ],
    };
  },
};
